import { Icon } from '@appcues/sonar';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons/faArrowUpRightFromSquare';
import useFeature from 'studio5/hooks/use-feature';
import { getAgentStudioUrl } from 'studio5/lib/platform';
import ButtonLink from './ButtonLink';

/** Classic's installation page covers mobile too; Agent Studio splits it out. */
export default function MobileLinkOutButton() {
  const hasMobileFlows = useFeature('MOBILE_FLOWS');

  if (!hasMobileFlows) {
    return null;
  }

  return (
    <ButtonLink
      forwardedAs="a"
      href={`${getAgentStudioUrl()}/settings/apps/mobile`}
      target="_blank"
      rel="noopener noreferrer"
    >
      Open Mobile in new App
      <Icon icon={faArrowUpRightFromSquare} size="small" />
    </ButtonLink>
  );
}
